export default __webpack_public_path__ + "static/media/louvre_front_side.810dd1f0.jpg";